
export class Account {
    username?: string;
    firstName?: string;
    lastName?: string;
    company?: string;
    tax?: string;
    email?: string;
    city?: string;
    zipCode?: string;
    country?: any;
    about?: string;
    address?: string;
    profileImage?: string;
  }

export class AccountUpdate {
  username?: string;
  firstName?: string;
  lastName?: string;
  company?: string;
  tax?: string;
  email?: string;
  city?: string;
  zipCode?: string;
  countryId?: any;
  about?: string;
  address?: string;
  }

export class Password {
  newPassword?: string;
  currentPassword?: string;
  repeatNewPassword?: string;
}
